import { render } from "./ParametersCard.vue?vue&type=template&id=3ab1b9a4&scoped=true"
import script from "./ParametersCard.vue?vue&type=script&lang=js"
export * from "./ParametersCard.vue?vue&type=script&lang=js"

import "./ParametersCard.vue?vue&type=style&index=0&id=3ab1b9a4&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab1b9a4"]])

export default __exports__